import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3defdac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mypage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card fa-fw" }, null, -1))
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Information", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "マイページでは、以下のことができます。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "ご自分の登録情報の変更"),
  /*#__PURE__*/_createElementVNode("li", null, "発注履歴の管理"),
  /*#__PURE__*/_createElementVNode("li", null, "保存見積もりの管理")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 入力データの利用について "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, " 入力された反響データは、御社が反響データを蓄積・分析していただく以外に、弊社が導入しているGISマーケティングツール等を活用して、御社に対して、より反響が出る配布エリア選定のご提案をさせていただくために利用させていただくことがあります。 "),
      /*#__PURE__*/_createElementVNode("li", null, " 入力いただいたデータはそのままの形で許可なく第三者に提供することはありません。なお、統計処理等を用いてエリアの特性（プロファイル）として皆様にご提供させていただくことがあります。 ")
    ])
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" 2021年5月1日"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ポストエクスプレス株式会社 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_User = _resolveComponent("User")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_List = _resolveComponent("List")!
  const _component_Checked = _resolveComponent("Checked")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" マイページ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      class: "box-card",
                      style: {"color":"#606266"}
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_InfoFilled)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(),
                          _hoisted_4
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse, {
                          modelValue: _ctx.activeNames,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_collapse_item, {
                              title: _ctx.pointTitle,
                              name: "1",
                              class: "no-border"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _hoisted_6
                              ]),
                              _: 1
                            }, 8, ["title"]),
                            _createVNode(_component_el_collapse_item, {
                              title: "利用規約",
                              name: "2",
                              class: "no-border"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              type: "flex",
              class: "row-bg",
              justify: "space-between",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 8,
                  style: {"text-align":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/usrinfo" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "primary" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_User)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 登録情報")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  style: {"text-align":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/hist" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "primary" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_List)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 発注管理")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  style: {"text-align":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/savedest" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "primary" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Checked)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 保存見積")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              type: "flex",
              class: "row-bg",
              justify: "center",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "info" }, {
                          default: _withCtx(() => [
                            _createTextVNode("戻る")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}